module.exports = __webpack_public_path__ + "img/table_190.95616dd9.jpg";